export const UserLicenceTypes = Object.freeze({
  legacy: 'legacy',
  subscription: 'subscription'
});
